<!-- ══ NAVIGATION ══ -->
<nav id="navbar" [class.scrolled]="isScrolled">
  <a href="#" class="nav-logo">
    <img src="grupogaeli_logo.png" alt="Grupo Gaeli" class="nav-logo-img" />
  </a>
  <ul class="nav-links">
    <li><a href="#normas">Normas</a></li>
    <li><a href="#servicios">Servicios</a></li>
    <li><a href="#proceso">Proceso</a></li>
    <li><a href="#academy">Formación Virtual</a></li>
    <li><a href="#acerca">Acerca de nosotros</a></li>
    <li><a href="https://aula.nx1.app" target="_blank" rel="noopener noreferrer">Aula virtual</a></li>
    <li><a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer">Cursos</a></li>
    <li><a href="https://wa.me/573203064734" target="_blank" rel="noopener noreferrer" class="nav-cta">Contáctenos</a></li>
    <li class="nav-social-links">
      <a href="https://www.instagram.com/grupogaeli/" target="_blank" rel="noopener noreferrer" class="nav-social" aria-label="Instagram">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
      </a>
      <a href="https://www.linkedin.com/in/grupo-gaeli-sas/" target="_blank" rel="noopener noreferrer" class="nav-social" aria-label="LinkedIn">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
      </a>
    </li>
  </ul>
</nav>

<!-- ══ HERO ══ -->
<section id="hero">
  <div class="hero-text">
    <div class="hero-badge"><span></span> Consultoría · Formación Virtual · Auditoría</div>
    <h1>Certifique su empresa.<br><em>Eleve su calidad.</em><br>Mitigue sus riesgos.</h1>
    <p>Acompañamos a organizaciones colombianas en el diseño, implementación y certificación de sistemas de gestión bajo normas ISO y la legislación nacional vigente.</p>
    <a href="#programs-strip" class="hero-academy-pill">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 14l9-5-9-5-9 5 9 5z"/><path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0112 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/></svg>
      <span>GAELI Academy — 4 diplomados virtuales disponibles</span>
      <svg class="pill-arrow" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/></svg>
    </a>
    <div class="hero-actions">
      <a href="#servicios" class="btn-primary">Conocer servicios</a>
      <a href="#programs-strip" class="btn-outline">Explorar cursos virtuales</a>
    </div>
    <div class="hero-stats">
      <div>
        <div class="hero-stat-num">+200</div>
        <div class="hero-stat-lbl">Empresas<br>certificadas</div>
      </div>
      <div>
        <div class="hero-stat-num">10+</div>
        <div class="hero-stat-lbl">Años de<br>experiencia</div>
      </div>
      <div>
        <div class="hero-stat-num">4</div>
        <div class="hero-stat-lbl">Estándares<br>dominados</div>
      </div>
    </div>
  </div>

  <div class="hero-visual">
    <div class="hero-card-stack">
      <div class="hcard hcard-main">
        <div class="hcard-icon">
          <svg viewBox="0 0 24 24"><path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>
        </div>
        <h4>ISO 9001 – Calidad</h4>
        <p>Sistema de gestión de calidad para optimizar procesos y satisfacer clientes.</p>
      </div>
      <div class="hcard hcard-accent">
        <div class="hcard-icon">
          <svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        </div>
        <h4>ISO 45001 – SST</h4>
        <p>Seguridad y salud en el trabajo bajo estándares globales.</p>
      </div>
    </div>
  </div>
</section>

<!-- ══ PROGRAMS STRIP ══ -->
<section id="programs-strip">
  <div class="ps-intro reveal">
    <div class="ps-intro-text">
      <div class="section-label">GAELI Academy — Formación Virtual</div>
      <h2 class="section-title">Diplomados virtuales<br>certificados</h2>
      <p class="section-sub">Programas 100% virtuales orientados a resultados reales. Certifícate en sistemas de gestión y sostenibilidad desde cualquier lugar.</p>
    </div>
    <a href="#academy" class="btn-outline ps-view-all">Ver todos los programas</a>
  </div>

  <div class="ps-grid">
    <div class="ps-card reveal reveal-delay-1">
      <div class="ps-tag">ISO 21001:2025</div>
      <h3>Auditoría ISO 21001:2025</h3>
      <p>Planifica, ejecuta y lidera auditorías internas en organizaciones educativas bajo estándares internacionales.</p>
      <div class="ps-card-footer">
        <span class="ps-badge">Diplomado</span>
        <a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer" class="ps-link">Ver programa →</a>
      </div>
    </div>
    <div class="ps-card ps-card--highlight reveal reveal-delay-2">
      <div class="ps-featured-badge">Recomendado</div>
      <div class="ps-tag">ISO 21001:2025</div>
      <h3>Diplomado ISO 21001:2025</h3>
      <p>Implementa y optimiza sistemas de gestión educativa de alto nivel bajo estándares internacionales.</p>
      <div class="ps-card-footer">
        <span class="ps-badge">Diplomado</span>
        <a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer" class="ps-link">Ver programa →</a>
      </div>
    </div>
    <div class="ps-card reveal reveal-delay-3">
      <div class="ps-tag">Diversidad e Inclusión</div>
      <h3>Gestión Estratégica de la Diversidad e Inclusión</h3>
      <p>Estrategias reales para construir organizaciones inclusivas y sostenibles con impacto medible.</p>
      <div class="ps-card-footer">
        <span class="ps-badge">Diplomado</span>
        <a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer" class="ps-link">Ver programa →</a>
      </div>
    </div>
    <div class="ps-card reveal reveal-delay-4">
      <div class="ps-tag">ISO 9001:2015</div>
      <h3>Implementación Estratégica del SGC</h3>
      <p>Diseña, implementa y mejora un sistema de gestión de calidad bajo ISO 9001:2015 con enfoque estratégico y práctico.</p>
      <div class="ps-card-footer">
        <span class="ps-badge">Diplomado</span>
        <a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer" class="ps-link">Ver programa →</a>
      </div>
    </div>
  </div>
</section>

<!-- ══ NORMAS ══ -->
<section id="normas">
  <div class="reveal"><div class="section-label">Estándares que dominamos</div></div>
  <div class="reveal reveal-delay-1"><h2 class="section-title">Normas en las que<br>somos expertos</h2></div>
  <div class="reveal reveal-delay-2"><p class="section-sub">Cada norma representa un pilar estratégico para su organización. Guiamos el proceso completo: diagnóstico, implementación y acompañamiento hasta la certificación.</p></div>

  <div class="normas-grid">
    <div class="norma-card reveal reveal-delay-1">
      <div class="norma-tag">ISO 9001:2015</div>
      <h3>Gestión de la Calidad</h3>
      <p>Estandarice procesos, mejore la satisfacción del cliente y demuestre la capacidad de su organización para entregar productos y servicios consistentes.</p>
    </div>
    <div class="norma-card reveal reveal-delay-2">
      <div class="norma-tag">ISO 14001:2015</div>
      <h3>Gestión Ambiental</h3>
      <p>Implemente un sistema de gestión ambiental que reduzca su huella ecológica, garantice el cumplimiento legal y abra nuevas oportunidades comerciales en licitaciones públicas y mercados exigentes.</p>
    </div>
    <div class="norma-card reveal reveal-delay-3">
      <div class="norma-tag">ISO 45001:2018</div>
      <h3>Seguridad y Salud en el Trabajo</h3>
      <p>Proteja a sus trabajadores mediante la identificación proactiva de peligros, evaluación de riesgos y control de incidentes laborales.</p>
    </div>
    <div class="norma-card reveal reveal-delay-4">
      <div class="norma-tag">Res. 0312/2019</div>
      <h3>Estándares Mínimos del SG-SST</h3>
      <p>Cumplimiento obligatorio de los estándares mínimos del Sistema de Gestión de Seguridad y Salud en el Trabajo según la legislación colombiana del Ministerio de Trabajo.</p>
    </div>
  </div>
</section>

<!-- ══ SERVICIOS ══ -->
<section id="servicios">
  <div class="reveal"><div class="section-label">Lo que hacemos</div></div>
  <div class="reveal reveal-delay-1"><h2 class="section-title">Nuestros servicios de<br>consultoría</h2></div>
  <div class="reveal reveal-delay-2"><p class="section-sub">Un acompañamiento integral desde la evaluación inicial hasta la certificación y el mantenimiento del sistema.</p></div>

  <div class="servicios-layout">
    <div class="servicio-list reveal">
      <div class="servicio-item" [class.active]="activeServicio === 0" (click)="setActiveServicio(0)">
        <div class="si-num">01</div>
        <div class="si-text">
          <h4>Diagnóstico y Evaluación Inicial</h4>
          <p>Análisis del estado actual frente a los requisitos normativos para identificar brechas y trazar la hoja de ruta.</p>
        </div>
      </div>
      <div class="servicio-item" [class.active]="activeServicio === 1" (click)="setActiveServicio(1)">
        <div class="si-num">02</div>
        <div class="si-text">
          <h4>Diseño e Implementación del Sistema</h4>
          <p>Construcción de la documentación, procedimientos y controles adaptados a su sector y tamaño.</p>
        </div>
      </div>
      <div class="servicio-item" [class.active]="activeServicio === 2" (click)="setActiveServicio(2)">
        <div class="si-num">03</div>
        <div class="si-text">
          <h4>Formación y Capacitación</h4>
          <p>Talleres y charlas dirigidas al equipo directivo, mandos medios y operativos sobre cultura de calidad y seguridad.</p>
        </div>
      </div>
      <div class="servicio-item" [class.active]="activeServicio === 3" (click)="setActiveServicio(3)">
        <div class="si-num">04</div>
        <div class="si-text">
          <h4>Auditorías Internas</h4>
          <p>Verificación del cumplimiento del sistema para preparar a la organización de cara a la auditoría de certificación.</p>
        </div>
      </div>
      <div class="servicio-item" [class.active]="activeServicio === 4" (click)="setActiveServicio(4)">
        <div class="si-num">05</div>
        <div class="si-text">
          <h4>Gestión de Riesgos Laborales</h4>
          <p>Identificación, valoración y control de peligros ocupacionales con matrices IPVR y planes de acción.</p>
        </div>
      </div>
      <div class="servicio-item" [class.active]="activeServicio === 5" (click)="setActiveServicio(5)">
        <div class="si-num">06</div>
        <div class="si-text">
          <h4>Mantenimiento y Mejora Continua</h4>
          <p>Soporte post-certificación para garantizar la vigencia y evolución del sistema de gestión.</p>
        </div>
      </div>
    </div>

    <div class="servicio-feature reveal reveal-delay-2">
      <div class="sf-icon">
        <svg viewBox="0 0 24 24"><path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>
      </div>
      <h3>Consultoría a la medida de su empresa</h3>
      <p>Cada organización es única. Nuestro enfoque personalizado asegura que el sistema de gestión se adapte a su cultura, procesos y objetivos estratégicos — no al revés.</p>
      <p>Contamos con consultores con formación internacional y amplia experiencia en sectores como manufactura, construcción, servicios, salud y comercio.</p>
      <div class="sf-tags">
        <span class="sf-tag">PYMES</span>
        <span class="sf-tag">Grandes empresas</span>
        <span class="sf-tag">Sector público</span>
        <span class="sf-tag">Construcción</span>
        <span class="sf-tag">Manufactura</span>
        <span class="sf-tag">Servicios</span>
      </div>
    </div>
  </div>
</section>

<!-- ══ PROCESO ══ -->
<section id="proceso">
  <div class="reveal"><div class="section-label">Nuestra metodología</div></div>
  <div class="reveal reveal-delay-1"><h2 class="section-title">Un camino claro hacia<br>su certificación</h2></div>
  <div class="reveal reveal-delay-2"><p class="section-sub">Seguimos una ruta estructurada que minimiza disrupciones a su operación y maximiza las probabilidades de éxito en la auditoría de certificación.</p></div>

  <div class="proceso-steps">
    <div class="paso reveal reveal-delay-1">
      <div class="paso-num">1</div>
      <h4>Diagnóstico</h4>
      <p>Evaluamos el estado actual vs. los requisitos normativos y elaboramos un plan de trabajo detallado.</p>
    </div>
    <div class="paso reveal reveal-delay-2">
      <div class="paso-num">2</div>
      <h4>Documentación</h4>
      <p>Documentamos el sistema: políticas, procedimientos, matrices de riesgo e indicadores de desempeño.</p>
    </div>
    <div class="paso reveal reveal-delay-3">
      <div class="paso-num">3</div>
      <h4>Implementación</h4>
      <p>Ejecutamos el sistema con capacitaciones, pilotos y ajustes hasta lograr la madurez requerida.</p>
    </div>
    <div class="paso reveal reveal-delay-4">
      <div class="paso-num">4</div>
      <h4>Auditoría Interna</h4>
      <p>Verificamos el cumplimiento y corregimos no conformidades antes de la auditoría de certificación.</p>
    </div>
    <div class="paso reveal" style="transition-delay:.5s">
      <div class="paso-num">5</div>
      <h4>Certificación</h4>
      <p>Le acompañamos durante el proceso con el organismo certificador hasta obtener el certificado.</p>
    </div>
  </div>
</section>

<!-- ══ ACERCA DE NOSOTROS ══ -->
<section id="acerca">

  <!-- Quiénes somos -->
  <div class="reveal"><div class="section-label">Somos Gaeli – Somos Sostenibilidad</div></div>
  <div class="reveal reveal-delay-1"><h2 class="section-title">Una empresa comprometida<br>con la transformación</h2></div>
  <div class="acerca-intro reveal reveal-delay-2">
    <p>Grupo GAELI S.A.S. es una compañía colombiana especializada en consultoría, auditoría, capacitación y soluciones digitales de formación en sistemas de gestión bajo estándares internacionales como ISO 9001, ISO 14001, ISO 45001, ISO 21001, NTC 5555, NTC 5580, NTC 5581, SGE21, Responsabilidad Social y Sostenibilidad.</p>
    <p>Acompañamos a organizaciones de diferentes sectores en su camino hacia la excelencia, el cumplimiento legal y la transformación sostenible. Nuestro enfoque integral combina <strong>experiencia técnica</strong>, <strong>innovación</strong>, <strong>formación continua</strong> y <strong>compromiso ético y social</strong>.</p>
    <p>Nos posicionamos como un aliado estratégico que no solo implementa sistemas, sino que desarrolla capacidades organizacionales sostenibles.</p>
  </div>

  <!-- Propósito y Visión -->
  <div class="acerca-pv-grid">
    <div class="acerca-pv-card reveal reveal-delay-1">
      <div class="acerca-pv-icon">
        <svg viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
      </div>
      <h3>Nuestro Propósito</h3>
      <p>Impulsar organizaciones conscientes, sostenibles y responsables, fortaleciendo sus sistemas de gestión a través de la integración de consultoría, auditoría y formación continua.</p>
      <p>Creemos que la verdadera transformación organizacional nace del desarrollo de las personas y la coherencia en la gestión. Nuestro propósito es generar valor real y duradero, promoviendo entornos de trabajo seguros, saludables y humanos.</p>
    </div>
    <div class="acerca-pv-card reveal reveal-delay-2">
      <div class="acerca-pv-icon">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
      </div>
      <h3>Nuestra Visión</h3>
      <p>Impulsar organizaciones conscientes, sostenibles y responsables a través de la integración de consultoría, auditoría y formación continua. Acompañamos a las empresas en la construcción de culturas organizacionales éticas, coherentes y orientadas a la sostenibilidad.</p>
      <p>A través de <strong>GAELI Academy</strong>, promovemos el aprendizaje continuo como eje fundamental para la transformación y la sostenibilidad de los resultados en el tiempo.</p>
    </div>
  </div>

  <!-- Valores corporativos -->
  <div class="reveal" style="margin-top: var(--section-pad);">
    <div class="section-label">Nuestros principios</div>
    <h2 class="section-title">Valores Corporativos</h2>
  </div>
  <div class="acerca-valores-grid">
    <div class="acerca-valor reveal reveal-delay-1">
      <div class="acerca-valor-num">1</div>
      <div>
        <h4>Ética y Transparencia</h4>
        <p>Actuamos con integridad, responsabilidad y transparencia en todas nuestras acciones, estableciendo relaciones de confianza con nuestros clientes y aliados.</p>
      </div>
    </div>
    <div class="acerca-valor reveal reveal-delay-2">
      <div class="acerca-valor-num">2</div>
      <div>
        <h4>Sostenibilidad</h4>
        <p>Integramos soluciones que respetan el medio ambiente, contribuyen a mitigar el cambio climático y generan beneficios sociales y económicos para las comunidades.</p>
      </div>
    </div>
    <div class="acerca-valor reveal reveal-delay-3">
      <div class="acerca-valor-num">3</div>
      <div>
        <h4>Excelencia</h4>
        <p>Nos comprometemos a ofrecer servicios de alta calidad, innovadores y adaptados a las necesidades de nuestros clientes, garantizando resultados que superen sus expectativas.</p>
      </div>
    </div>
  </div>

  <!-- Modelo Gaeli -->
  <div class="acerca-modelo reveal">
    <div class="acerca-modelo-label">Nuestro diferenciador</div>
    <h3>Modelo GAELI: Consultoría + Formación + Transformación</h3>
    <p>En GAELI integramos tres pilares fundamentales que garantizan que los sistemas implementados se mantengan en el tiempo y generen valor real.</p>
    <div class="acerca-pilares">
      <div class="acerca-pilar">
        <div class="acerca-pilar-icon">
          <svg viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
        </div>
        <h4>Consultoría Estratégica</h4>
        <p>Diseño e implementación de sistemas de gestión adaptados a cada organización.</p>
      </div>
      <div class="acerca-pilar">
        <div class="acerca-pilar-icon">
          <svg viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        </div>
        <h4>Auditoría y Cumplimiento</h4>
        <p>Verificación independiente del cumplimiento normativo y mejora continua del sistema.</p>
      </div>
      <div class="acerca-pilar">
        <div class="acerca-pilar-icon">
          <svg viewBox="0 0 24 24"><path d="M12 14l9-5-9-5-9 5 9 5z"/><path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/></svg>
        </div>
        <h4>Formación Continua — GAELI Academy</h4>
        <p>Plataforma digital con cursos, diplomados y entrenamientos en sistemas de gestión, SST, sostenibilidad y wellness corporativo.</p>
      </div>
    </div>
  </div>

  <!-- Propuesta de valor -->
  <div class="acerca-propuesta reveal">
    <blockquote>"En GAELI no solo implementamos sistemas de gestión,<br><strong>formamos organizaciones conscientes.</strong>"</blockquote>
    <p>Integramos consultoría, auditoría y formación digital para garantizar resultados sostenibles.</p>
    <a href="https://wa.me/573203064734" target="_blank" rel="noopener noreferrer" class="btn-primary">Conocer más sobre nosotros</a>
  </div>

</section>

<!-- ══ GAELI ACADEMY ══ -->
<section id="academy">
  <div class="reveal"><div class="section-label">GAELI Academy — Formación Virtual</div></div>
  <div class="reveal reveal-delay-1"><h2 class="section-title">Formación virtual para<br>organizaciones que crecen</h2></div>
  <div class="reveal reveal-delay-2"><p class="section-sub">Transformamos la sostenibilidad en conocimiento aplicado. Formamos profesionales y organizaciones capaces de liderar procesos de cambio, calidad e inclusión. Programas 100% virtuales, certificados y orientados a resultados reales.</p></div>

  <!-- ¿Por qué elegirnos? -->
  <div class="acad-reasons">
    <div class="acad-reason reveal reveal-delay-1">
      <div class="acad-reason-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
      </div>
      <span>100% virtual y flexible</span>
    </div>
    <div class="acad-reason reveal reveal-delay-2">
      <div class="acad-reason-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
      </div>
      <span>Contenidos actualizados y aplicables</span>
    </div>
    <div class="acad-reason reveal reveal-delay-3">
      <div class="acad-reason-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
      </div>
      <span>Enfoque práctico y empresarial</span>
    </div>
    <div class="acad-reason reveal reveal-delay-4">
      <div class="acad-reason-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>
      </div>
      <span>Certificación incluida</span>
    </div>
    <div class="acad-reason reveal reveal-delay-1">
      <div class="acad-reason-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
      </div>
      <span>Acompañamiento experto</span>
    </div>
    <div class="acad-reason reveal reveal-delay-2">
      <div class="acad-reason-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>
      </div>
      <span>Impacto directo en tu organización</span>
    </div>
  </div>

  <!-- Portafolio -->
  <div class="acad-block-head reveal">
    <div class="section-label">Nuestros programas</div>
    <h3 class="acad-block-title">Portafolio de formación</h3>
  </div>

  <div class="acad-courses">

    <!-- Diplomado 1: Auditoría ISO 21001:2025 -->
    <div class="acad-course reveal reveal-delay-1">
      <div class="acad-course-body">
        <div class="acad-course-tag">Diplomado · ISO 21001:2025</div>
        <h3>Auditoría<br>ISO 21001:2025</h3>
        <p class="acad-course-sub">Domina la auditoría en organizaciones educativas</p>
        <p class="acad-course-desc">Programa especializado para formar auditores internos bajo la norma ISO 21001:2025, con enfoque práctico y aplicable.</p>
        <div class="acad-course-obj">
          <strong>Objetivo</strong>
          <p>Desarrollar competencias para planificar, ejecutar y liderar auditorías internas que garanticen la calidad en organizaciones educativas.</p>
        </div>
      </div>
      <div class="acad-course-learn">
        <p class="acad-list-label">Lo que aprenderás</p>
        <ul>
          <li>Interpretación de la norma ISO 21001</li>
          <li>Planificación de auditorías</li>
          <li>Ejecución y recolección de evidencias</li>
          <li>Gestión de hallazgos</li>
          <li>Mejora continua</li>
        </ul>
      </div>
      <div class="acad-course-value">
        <p class="acad-list-label">Valor para el cliente</p>
        <div class="acad-tags">
          <span>Mejora en procesos educativos</span>
          <span>Cumplimiento normativo</span>
          <span>Fortalecimiento institucional</span>
          <span>Perfil profesional competitivo</span>
        </div>
      </div>
      <div class="acad-course-footer acad-cta-row">
        <a routerLink="/cursos/auditoria-iso-21001" class="acad-cta">Más información</a>
        <a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer" class="acad-cta-outline">Inscribirme</a>
      </div>
    </div>

    <!-- Diplomado 2: ISO 21001:2025 (destacado) -->
    <div class="acad-course acad-course--featured reveal reveal-delay-2">
      <div class="acad-course-body">
        <div class="acad-course-tag">Diplomado · ISO 21001:2025</div>
        <h3>Diplomado<br>ISO 21001:2025</h3>
        <p class="acad-course-sub">Implementa sistemas de gestión educativa de alto nivel</p>
        <p class="acad-course-desc">Aprende a estructurar, implementar y optimizar sistemas bajo estándares internacionales.</p>
        <div class="acad-course-obj">
          <strong>Objetivo</strong>
          <p>Capacitar en la implementación y mejora del sistema de gestión para organizaciones educativas conforme a ISO 21001:2025.</p>
        </div>
      </div>
      <div class="acad-course-learn">
        <p class="acad-list-label">Lo que aprenderás</p>
        <ul>
          <li>Contexto organizacional</li>
          <li>Liderazgo estratégico</li>
          <li>Gestión de procesos</li>
          <li>Evaluación del desempeño</li>
          <li>Mejora continua</li>
        </ul>
      </div>
      <div class="acad-course-value">
        <p class="acad-list-label">Resultados esperados</p>
        <div class="acad-tags">
          <span>Procesos organizados y eficientes</span>
          <span>Mayor calidad educativa</span>
          <span>Ventaja competitiva institucional</span>
          <span>Preparación para certificación</span>
        </div>
      </div>
      <div class="acad-course-footer acad-cta-row">
        <a routerLink="/cursos/diplomado-iso-21001" class="acad-cta">Más información</a>
        <a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer" class="acad-cta-outline">Inscribirme</a>
      </div>
    </div>

    <!-- Diplomado 3: Gestión Estratégica de la Diversidad e Inclusión -->
    <div class="acad-course reveal reveal-delay-3">
      <div class="acad-course-body">
        <div class="acad-course-tag">Diplomado · Diversidad e Inclusión</div>
        <h3>Gestión Estratégica de la Diversidad e Inclusión</h3>
        <p class="acad-course-sub">Construye organizaciones inclusivas y sostenibles</p>
        <p class="acad-course-desc">Programa enfocado en estrategias reales de diversidad e inclusión organizacional.</p>
        <div class="acad-course-obj">
          <strong>Objetivo</strong>
          <p>Fortalecer la gestión organizacional mediante la implementación de estrategias inclusivas y sostenibles.</p>
        </div>
      </div>
      <div class="acad-course-learn">
        <p class="acad-list-label">Lo que aprenderás</p>
        <ul>
          <li>Diversidad e inclusión en el entorno organizacional</li>
          <li>Marco normativo</li>
          <li>Cultura inclusiva</li>
          <li>Estrategias de implementación</li>
          <li>Medición de impacto</li>
        </ul>
      </div>
      <div class="acad-course-value">
        <p class="acad-list-label">Impacto organizacional</p>
        <div class="acad-tags">
          <span>Mejor clima laboral</span>
          <span>Mayor innovación</span>
          <span>Cumplimiento legal</span>
          <span>Reputación organizacional</span>
        </div>
      </div>
      <div class="acad-course-footer acad-cta-row">
        <a routerLink="/cursos/diversidad-e-inclusion" class="acad-cta">Más información</a>
        <a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer" class="acad-cta-outline">Inscribirme</a>
      </div>
    </div>

    <!-- Diplomado 4: Implementación Estratégica del SGC ISO 9001 -->
    <div class="acad-course reveal reveal-delay-4">
      <div class="acad-course-body">
        <div class="acad-course-tag">Diplomado · ISO 9001:2015</div>
        <h3>Implementación Estratégica del Sistema de Gestión de Calidad</h3>
        <p class="acad-course-sub">Formación práctica para organizaciones más competitivas y sostenibles</p>
        <p class="acad-course-desc">Aprende a diseñar, implementar y mejorar el sistema de gestión de calidad bajo ISO 9001:2015 con un enfoque estratégico y aplicable a cualquier sector.</p>
        <div class="acad-course-obj">
          <strong>Objetivo</strong>
          <p>Desarrollar las competencias para implementar y mantener un Sistema de Gestión de Calidad eficiente y sostenible conforme a ISO 9001:2015.</p>
        </div>
      </div>
      <div class="acad-course-learn">
        <p class="acad-list-label">Lo que aprenderás</p>
        <ul>
          <li>Fundamentos del Sistema de Gestión de Calidad</li>
          <li>Diseño e implementación del SGC</li>
          <li>Control y gestión de la información documentada</li>
          <li>Auditoría, evaluación y mejora del SGC</li>
        </ul>
      </div>
      <div class="acad-course-value">
        <p class="acad-list-label">Valor para el cliente</p>
        <div class="acad-tags">
          <span>Formación especializada</span>
          <span>Certificación de calidad</span>
          <span>Enfoque en sostenibilidad</span>
          <span>Docentes expertos</span>
        </div>
      </div>
      <div class="acad-course-footer acad-cta-row">
        <a routerLink="/cursos/sgc-iso-9001" class="acad-cta">Más información</a>
        <a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer" class="acad-cta-outline">Inscribirme</a>
      </div>
    </div>

  </div>

  <!-- Metodología -->
  <div class="acad-metod reveal">
    <p class="acad-metod-label">Metodología</p>
    <div class="acad-metod-grid">
      <div class="acad-metod-item">
        <div class="acad-metod-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 10l4.553-2.069A1 1 0 0121 8.845v6.31a1 1 0 01-1.447.894L15 14M3 8a2 2 0 012-2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"/></svg>
        </div>
        <span>Clases virtuales</span>
      </div>
      <div class="acad-metod-item">
        <div class="acad-metod-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/></svg>
        </div>
        <span>Material descargable</span>
      </div>
      <div class="acad-metod-item">
        <div class="acad-metod-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/></svg>
        </div>
        <span>Casos prácticos</span>
      </div>
      <div class="acad-metod-item">
        <div class="acad-metod-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        </div>
        <span>Evaluaciones</span>
      </div>
      <div class="acad-metod-item">
        <div class="acad-metod-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
        </div>
        <span>Acompañamiento permanente</span>
      </div>
    </div>
  </div>

  <!-- Certificación + CTA final -->
  <div class="acad-cert reveal">
    <div class="acad-cert-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>
    </div>
    <div class="acad-cert-text">
      <h4>Certificación al finalizar</h4>
      <p>Al finalizar cada programa, el estudiante recibirá certificación que valida las competencias adquiridas.</p>
    </div>
    <a href="https://extraclase.nx1.app/entidad/gaeli" target="_blank" rel="noopener noreferrer" class="btn-primary">Explorar todos los cursos</a>
  </div>

</section>

<!-- ══ CTA ══ -->
<section id="cta">
  <h2 class="reveal">¿Listo para certificar<br>su empresa?</h2>
  <p class="reveal reveal-delay-1">Hable con uno de nuestros consultores hoy mismo. La primera sesión de diagnóstico es sin costo y sin compromisos.</p>
  <a href="https://wa.me/573203064734" target="_blank" rel="noopener noreferrer" class="btn-white reveal reveal-delay-2">Solicitar diagnóstico gratuito</a>
  <p class="reveal reveal-delay-3" style="margin-top:16px; font-size:.9rem; color:rgba(255,255,255,.65);">
    ¿Prefiere el correo? escríbanos a
    <a href="mailto:info@grupogaeli.com" style="color:white; text-decoration:underline;">info&#64;grupogaeli.com</a>
  </p>
</section>

<!-- ══ FOOTER ══ -->
<footer>
  <div class="footer-grid">
    <div class="footer-brand">
      <a href="#" class="nav-logo">
        <img src="grupogaeli_logo.png" alt="Grupo Gaeli" class="nav-logo-img" style="filter: brightness(0) invert(1);" />
      </a>
      <p>Consultoría especializada en sistemas de gestión de calidad, seguridad y salud en el trabajo para empresas colombianas.</p>
      <div class="footer-social">
        <a href="https://www.linkedin.com/in/grupo-gaeli-sas/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <svg viewBox="0 0 24 24"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
        </a>
        <a href="https://wa.me/573203064734" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
          <svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>
        </a>
        <a href="mailto:info@grupogaeli.com" aria-label="Email">
          <svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
        </a>
      </div>
    </div>

    <div class="footer-col">
      <h5>Servicios</h5>
      <ul>
        <li><a href="#">Diagnóstico inicial</a></li>
        <li><a href="#">Implementación ISO</a></li>
        <li><a href="#academy">Formación Virtual</a></li>
        <li><a href="#">Capacitaciones</a></li>
        <li><a href="#">Auditorías internas</a></li>
        <li><a href="#">Gestión de riesgos</a></li>
      </ul>
    </div>

    <div class="footer-col">
      <h5>Normas</h5>
      <ul>
        <li><a href="#">ISO 9001:2015</a></li>
        <li><a href="#">ISO 14001:2015</a></li>
        <li><a href="#">ISO 45001:2018</a></li>
        <li><a href="#">Res. 0312/2019</a></li>
        <li><a href="#">SG-SST</a></li>
      </ul>
    </div>

    <div class="footer-col">
      <h5>Contacto</h5>
      <ul>
        <li><a href="mailto:info@grupogaeli.com">info&#64;grupogaeli.com</a></li>
        <li><a href="https://wa.me/573203064734" target="_blank" rel="noopener noreferrer">+57 320 306 4734</a></li>
        <li><a href="#">Bucaramanga, Colombia</a></li>
        <li><a href="#">Política de privacidad</a></li>
      </ul>
    </div>
  </div>

  <div class="footer-bottom">
    <span>© 2025 Gaeli – Gestión & Calidad Corporativa. Todos los derechos reservados.</span>
    <a href="#">Política de privacidad</a>
  </div>
</footer>
